import { render, staticRenderFns } from "./CreateOooOosDialog.vue?vue&type=template&id=6d0492fb"
import script from "./CreateOooOosDialog.vue?vue&type=script&lang=js"
export * from "./CreateOooOosDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports